import React from 'react';

import ImgCybersec1 from '../../../assets/icon-training.png';
import ImgCybersec2 from '../../../assets/icon-employee.png';
import ImgCybersec3 from '../../../assets/icon-business.png';
import ImgCybersec4 from '../../../assets/icon-certificate.png';

interface IIntroducingSectionProps {
  settings: any;
  playFlag: boolean;
  scrollRef: React.LegacyRef<HTMLDivElement> | undefined;
}

const IntroducingSection: React.FunctionComponent<IIntroducingSectionProps> = ({
  settings,
  playFlag,
  scrollRef,
}) => {
  const [state, setState] = React.useState({
    cybersecItroducing: 0,
  });

  const playCybersecItroducing = (next: number) => {
    if (!next) {
      next = state.cybersecItroducing;
    }
    setState({ cybersecItroducing: next++ });
    if (next <= 4) {
      setTimeout(() => playCybersecItroducing(next), 1000);
    }
  };
  React.useEffect(() => {
    if (playFlag) {
      playCybersecItroducing(1);
    }
  }, [playFlag]);
  return (
    <div className="introducing-section" ref={scrollRef}>
      <div className="section-container">
        <div className="introducing-section-title">
          <span
            dangerouslySetInnerHTML={{
              __html: settings?.cybersecTrainingHubFeature,
            }}
          />
        </div>
        <div className="cybersec-introducing-list">
          <div className="introducing-circle-1" />
          <div className="introducing-circle-2" />
          <div
            className={`cybersec-introducing-item animation ${
              state.cybersecItroducing >= 1 ? 'fade-in' : ''
            }`}
          >
            <div className="introducing-img">
              <img width="147px" src={ImgCybersec1} alt="" />
            </div>
            <div className="introducing-title">
              {settings?.introducingTitle1}
            </div>
          </div>
          <div
            className={`cybersec-introducing-item animation ${
              state.cybersecItroducing >= 2 ? 'fade-in' : ''
            }`}
          >
            <div className="introducing-img">
              <img width="159px" src={ImgCybersec2} alt="" />
            </div>
            <div className="introducing-title">
              {settings?.introducingTitle2}
            </div>
          </div>
          <div
            className={`cybersec-introducing-item animation ${
              state.cybersecItroducing >= 3 ? 'fade-in' : ''
            }`}
          >
            <div className="introducing-img">
              <img width="135px" src={ImgCybersec3} alt="" />
            </div>
            <div className="introducing-title">
              {settings?.introducingTitle3}
            </div>
          </div>
          <div
            className={`cybersec-introducing-item animation ${
              state.cybersecItroducing >= 4 ? 'fade-in' : ''
            }`}
          >
            <div className="introducing-img">
              <img width="167px" src={ImgCybersec4} alt="" />
            </div>
            <div className="introducing-title">
              {settings?.introducingTitle4}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroducingSection;
